// Copyright (c) 2022 Proto Labs, Inc. All Rights Reserved.

import isNil from 'lodash/isNil';

/**
 * Get QueryString from key value pair
 * @param {Object} obj
 * @return {String}
 */
export function createQueryStringFromObject(obj: any) {
	let queryString = '';
	if (obj && Object.keys(obj).length) {
		queryString = `?${Object.keys(obj)
			.map((item) => `${item}=${encodeURIComponent(obj[item])}`)
			.join('&')}`;
	}
	return queryString;
}

/**
 * Create a query string from an object of parameters that does not include null or undefined values
 */
export function createQueryString<T extends Record<string, unknown>>(params: T): string {
	let queryString = '';

	const keys = Object.keys(params);
	if (keys.length > 0) {
		const queryParts: string[] = [];
		keys.forEach((key) => {
			const value = params[key];
			if (!isNil(value)) {
				queryParts.push(`${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`);
			}
		});

		if (queryParts.length > 0) {
			queryString = `?${queryParts.join('&')}`;
		}
	}

	return queryString;
}

/**
 * Return querystring value from name
 * @param {String} name
 * @return {String}
 */
export function getQueryStringValue(name: string) {
	const currentLocationDecoded = new URL(decodeURIComponent(window.location.href));
	const params = new URLSearchParams(currentLocationDecoded.search);
	return params.get(name);
}

export default {
	createQueryStringFromObject,
	getQueryStringValue,
};
